export default "__VITE_ASSET__bb444360__"